export const InsertIncentive = (value) => {
  return {
    slipImage: value.slipImage
      ? value.slipImage.originFileObj ||
        (value.slipImage[0] && value.slipImage[0].originFileObj) ||
        value.slipImage
      : null,
    employeeId: value.employeeId,
    branchId: value.branchId,
    branchName: value.branchName,
    barcodeValue: value.barcodeValue,
    scanTimestamp: value.scanTimestamp,
    priceBill: value.priceBill,
  };
};
